import React from 'react';
import download from '../../../assets/img/icons/financialReport/bx_bx-download.svg';
import s from '../FinancialReport.module.css';

const StatReportActions = ({
	callback,
}: {
	callback: (action: string) => void;
}) => {
	return (
		<div className={s.tableActions}>
			<button onClick={() => callback('download')}>
				<img src={download} alt="download" />
			</button>
			{/*<button onClick={() => callback('show')}>
				<img src={show} alt="show" />
			</button>*/}
		</div>
	);
};

export default StatReportActions;
